"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDelaySchema = exports.isDurationSchema = void 0;
var tslib_1 = require("tslib");
var json_pointer_1 = (0, tslib_1.__importDefault)(require("json-pointer"));
var json_schema_validator_catalytic_web_1 = require("@catalytic/json-schema-validator-catalytic-web");
var view_1 = require("@catalytic/view");
var allPass_1 = (0, tslib_1.__importDefault)(require("ramda/src/allPass"));
var omit_1 = (0, tslib_1.__importDefault)(require("ramda/src/omit"));
var pathEq_1 = (0, tslib_1.__importDefault)(require("ramda/src/pathEq"));
var pathSatisfies_1 = (0, tslib_1.__importDefault)(require("ramda/src/pathSatisfies"));
var DEFAULT_VIEW_TYPE = view_1.NodeType.TEXT_AREA_VIEW;
function addViewAlternates(alternates, defaults) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, defaults), { alternates: Array.from(new Set(((defaults || {}).alternates || []).concat(alternates))).sort() });
}
function concateParentPointer(reference) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var path = typeof reference === 'string'
        ? json_pointer_1.default.parse(reference).concat(keys)
        : keys;
    return json_pointer_1.default.compile(path);
}
var omitAlternatives = (0, omit_1.default)(['alternatives']);
var omitEnum = (0, omit_1.default)(['enum']);
function addEnumerationToViewOptions(schema, view) {
    var typedSchema = omitEnum(schema);
    view.options = anyToView(typedSchema, (0, tslib_1.__assign)((0, tslib_1.__assign)({ reference: '' }, omitAlternatives(view)), { schemaReference: concateParentPointer(view.schemaReference || '', 'enum') }));
    return view;
}
function addItemsToViewOptions(schema, view) {
    var optionView = anyToView(schema.items, (0, tslib_1.__assign)((0, tslib_1.__assign)({ reference: '' }, omitAlternatives(view)), { schemaReference: concateParentPointer(view.schemaReference || '', 'items') }));
    view.options = optionView.options || optionView;
    return view;
}
function addItemsToViewItems(schema, view) {
    view.items = anyToView(schema.items, (0, tslib_1.__assign)((0, tslib_1.__assign)({ reference: '' }, omitAlternatives(view)), { schemaReference: concateParentPointer(view.schemaReference || '', 'items') }));
    return view;
}
function anyEnumerationToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.SELECTION_VIEW, view_1.NodeType.RADIO_SELECTION_VIEW], defaults);
    return (0, view_1.selectionView)(addEnumerationToViewOptions(schema, view));
}
function arrayObjectWithRequiredBooleanPropertyToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.BOARD_VIEW,
        view_1.NodeType.CHECKBOX_SELECTION_VIEW,
        view_1.NodeType.GALLERY_VIEW,
        view_1.NodeType.TABLE_VIEW
    ], defaults);
    return (0, view_1.tableView)(addItemsToViewItems(schema, view));
}
function arrayObjectWithDatePropertyToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.BOARD_VIEW,
        view_1.NodeType.CALENDAR_VIEW,
        view_1.NodeType.GALLERY_VIEW,
        view_1.NodeType.TABLE_VIEW
    ], defaults);
    return (0, view_1.tableView)(addItemsToViewItems(schema, view));
}
function arrayObjectToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.BOARD_VIEW, view_1.NodeType.GALLERY_VIEW, view_1.NodeType.TABLE_VIEW], defaults);
    var items = schema.items;
    var properties = (items || {}).properties;
    if (properties && typeof properties === 'object') {
        for (var _i = 0, _a = Object.values(properties); _i < _a.length; _i++) {
            var property = _a[_i];
            switch (property.type) {
                case json_schema_validator_catalytic_web_1.JSONType.BOOLEAN:
                    if (!property.nullable && property.default !== undefined) {
                        return arrayObjectWithRequiredBooleanPropertyToView(schema, view);
                    }
                    break;
                case json_schema_validator_catalytic_web_1.JSONType.STRING:
                    switch (property.format) {
                        case json_schema_validator_catalytic_web_1.JSONFormat.DATE:
                        case json_schema_validator_catalytic_web_1.JSONFormat.DATE_TIME:
                            return arrayObjectWithDatePropertyToView(schema, view);
                    }
            }
        }
    }
    return (0, view_1.tableView)(addItemsToViewItems(schema, view));
}
function tupleDateToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.DATE_RANGE_VIEW], defaults);
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
function tupleDateTimeToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.DATE_RANGE_VIEW, view_1.NodeType.DATE_TIME_RANGE_VIEW], defaults);
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
function arrayDateToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.CALENDAR_VIEW], defaults);
    if (schema.maxItems === 2 && schema.minItems === 2) {
        return tupleDateToView(schema, view);
    }
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
function arrayDateTimeToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.CALENDAR_VIEW], defaults);
    if (schema.maxItems === 2 && schema.minItems === 2) {
        return tupleDateTimeToView(schema, view);
    }
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
function tupleNumberToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.CURRENCY_RANGE_VIEW,
        view_1.NodeType.NUMBER_RANGE_VIEW,
        view_1.NodeType.PERCENT_RANGE_VIEW,
        view_1.NodeType.TIME_RANGE_VIEW
    ], defaults);
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
function arrayAnyToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.CHECKBOX_SELECTION_VIEW,
        view_1.NodeType.LIST_VIEW,
        view_1.NodeType.MULTIPLE_SELECTION_VIEW
    ], defaults);
    if (schema.enum) {
        return (0, view_1.multipleSelectionView)(addEnumerationToViewOptions(schema, view));
    }
    var items = schema.items;
    if (!items) {
        return (0, view_1.multipleSelectionView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { options: anyToView({ type: json_schema_validator_catalytic_web_1.JSONType.STRING }, {
                schemaReference: concateParentPointer(view.schemaReference || '', 'items')
            }), reference: '' }));
    }
    switch (items.type) {
        case json_schema_validator_catalytic_web_1.JSONType.OBJECT:
            return arrayObjectToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.NUMBER:
            if (schema.maxItems === 2 && schema.minItems === 2) {
                return tupleNumberToView(schema, view);
            }
            break;
        case json_schema_validator_catalytic_web_1.JSONType.STRING:
            switch (items.format) {
                case json_schema_validator_catalytic_web_1.JSONFormat.DATE:
                    return arrayDateToView(schema, view);
                case json_schema_validator_catalytic_web_1.JSONFormat.DATE_TIME:
                    return arrayDateTimeToView(schema, view);
            }
    }
    return (0, view_1.multipleSelectionView)(addItemsToViewOptions(schema, view));
}
exports.isDurationSchema = (0, allPass_1.default)([
    (0, pathEq_1.default)(['type'], 'object'),
    (0, pathEq_1.default)(['properties', 'days', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'hours', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'minutes', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'months', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'seconds', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'weekdays', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'weeks', 'type'], 'number'),
    (0, pathEq_1.default)(['properties', 'years', 'type'], 'number')
]);
exports.isDelaySchema = (0, allPass_1.default)([
    (0, pathEq_1.default)(['type'], 'object'),
    (0, pathEq_1.default)(['properties', 'startsWhen', 'type'], 'string'),
    (0, pathSatisfies_1.default)(exports.isDurationSchema, ['properties', 'duration'])
]);
function booleanWithDefaultToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.CHECKBOX_VIEW, view_1.NodeType.SWITCH_VIEW, view_1.NodeType.TOGGLE_SWITCH_VIEW], defaults);
    return (0, view_1.toggleSwitchView)(view);
}
function booleanToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.TOGGLE_SWITCH_VIEW], defaults);
    if (schema.default !== undefined) {
        return booleanWithDefaultToView(schema, view);
    }
    return (0, view_1.toggleSwitchView)(view);
}
function integerToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.CURRENCY_VIEW,
        view_1.NodeType.PERCENT_VIEW,
        view_1.NodeType.INTEGER_VIEW,
        view_1.NodeType.NUMBER_VIEW,
        view_1.NodeType.RELATIVE_TIME_VIEW
    ], defaults);
    return (0, view_1.integerView)(view);
}
function nullToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.TEXT_VIEW], defaults);
    return (0, view_1.textView)(view);
}
function numberToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.CURRENCY_VIEW,
        view_1.NodeType.PERCENT_VIEW,
        view_1.NodeType.INTEGER_VIEW,
        view_1.NodeType.NUMBER_VIEW,
        view_1.NodeType.RELATIVE_TIME_VIEW
    ], defaults);
    return (0, view_1.numberView)(view);
}
function objectPropertiesToViews(schema, view) {
    var properties = schema.properties;
    if (properties && typeof properties === 'object') {
        return Object.entries(properties).map(function (_a) {
            var key = _a[0], schema = _a[1];
            return anyToView(schema, {
                reference: concateParentPointer(view.reference || '', key),
                schemaReference: concateParentPointer(view.schemaReference || '', 'properties', key)
            });
        });
    }
    return [];
}
function objectDelayToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.RELATIVE_DELAY_VIEW], defaults);
    return (0, view_1.groupView)(view, objectPropertiesToViews(schema, view));
}
function objectDurationToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.RELATIVE_DURATION_VIEW], defaults);
    return (0, view_1.groupView)(view, objectPropertiesToViews(schema, view));
}
function objectToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.GROUP_VIEW], defaults);
    if ((0, exports.isDelaySchema)(schema)) {
        return objectDelayToView(schema, view);
    }
    if ((0, exports.isDurationSchema)(schema)) {
        return objectDurationToView(schema, view);
    }
    return (0, view_1.groupView)(view, objectPropertiesToViews(schema, view));
}
function stringDateToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.CALENDAR_VIEW, view_1.NodeType.DATE_VIEW], (0, tslib_1.__assign)({ formatMatcher: 'best fit', month: 'numeric', day: 'numeric', year: 'numeric' }, defaults));
    return (0, view_1.dateView)(view);
}
function stringDateTimeToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.CALENDAR_VIEW,
        view_1.NodeType.DATE_TIME_VIEW,
        view_1.NodeType.DATE_VIEW,
        view_1.NodeType.TIME_VIEW
    ], (0, tslib_1.__assign)({ formatMatcher: 'best fit', month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }, defaults));
    return (0, view_1.dateTimeView)(view);
}
function stringEmailToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.EMAIL_VIEW], defaults);
    return (0, view_1.emailView)(view);
}
function stringFileToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.FILE_VIEW], defaults);
    return (0, view_1.fileView)(view);
}
function stringJSONToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.CODE_VIEW], defaults);
    return (0, view_1.codeView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { lang: 'json' }));
}
function stringPasswordToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.PASSWORD_VIEW], defaults);
    return (0, view_1.passwordView)(view);
}
function stringReferenceFileImageToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.IMAGE_REFERENCE_VIEW], defaults);
    return (0, view_1.fileReferenceView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { refType: schema.refType }));
}
function stringReferenceFileToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.FILE_REFERENCE_VIEW], defaults);
    if (typeof schema.contentMediaType === 'string' &&
        schema.contentMediaType.startsWith('image/')) {
        return stringReferenceFileImageToView(schema, view);
    }
    return (0, view_1.fileReferenceView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { refType: schema.refType }));
}
function stringReferenceTableFilesToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.FILE_TABLE_REFERENCE_VIEW], defaults);
    return (0, view_1.referenceView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { refType: schema.refType }));
}
function stringReferenceTableToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.REFERENCE_VIEW], defaults);
    if (typeof schema.contentMediaType === 'string') {
        return stringReferenceTableFilesToView(schema, view);
    }
    return (0, view_1.referenceView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { refType: schema.refType }));
}
function stringReferenceToView(schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.REFERENCE_VIEW], defaults);
    switch (schema.refType) {
        case json_schema_validator_catalytic_web_1.JSONRefType.FILE:
            return stringReferenceFileToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONRefType.DATA_TABLE:
            return stringReferenceTableToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONRefType.ACTOR:
        case json_schema_validator_catalytic_web_1.JSONRefType.APP:
        case json_schema_validator_catalytic_web_1.JSONRefType.CONTEXT:
        case json_schema_validator_catalytic_web_1.JSONRefType.CONTEXT_TYPE:
        case json_schema_validator_catalytic_web_1.JSONRefType.DATA_TABLE_ROW:
        case json_schema_validator_catalytic_web_1.JSONRefType.DELAY:
        case json_schema_validator_catalytic_web_1.JSONRefType.DURATION:
        case json_schema_validator_catalytic_web_1.JSONRefType.FIELD:
        case json_schema_validator_catalytic_web_1.JSONRefType.GUEST:
        case json_schema_validator_catalytic_web_1.JSONRefType.LITERAL_DATETIME:
        case json_schema_validator_catalytic_web_1.JSONRefType.TASK:
        case json_schema_validator_catalytic_web_1.JSONRefType.STEP:
        case json_schema_validator_catalytic_web_1.JSONRefType.TEAM:
            return (0, view_1.referenceView)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, view), { refType: schema.refType }));
    }
    return (0, view_1.textAreaView)(view);
}
function stringTimeToView(_schema, defaults) {
    var view = addViewAlternates([view_1.NodeType.TIME_VIEW], (0, tslib_1.__assign)({ formatMatcher: 'best fit', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }, defaults));
    return (0, view_1.timeView)(view);
}
function stringToView(schema, defaults) {
    var view = addViewAlternates([
        view_1.NodeType.RICH_TEXT_VIEW,
        view_1.NodeType.TEXT_AREA_VIEW,
        view_1.NodeType.TEXT_VIEW,
        view_1.NodeType.URL_VIEW
    ], defaults);
    if (typeof schema.format === 'string') {
        switch (schema.format) {
            case json_schema_validator_catalytic_web_1.JSONFormat.BINARY:
                return stringFileToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.DATE:
                return stringDateToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.DATE_TIME:
                return stringDateTimeToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.EMAIL:
                return stringEmailToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.JSON:
                return stringJSONToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.PASSWORD:
                return stringPasswordToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.REF:
                return stringReferenceToView(schema, view);
            case json_schema_validator_catalytic_web_1.JSONFormat.TIME:
                return stringTimeToView(schema, view);
        }
    }
    return (0, view_1.textAreaView)(view);
}
function anyToView(schema, defaults) {
    var displayOnly = schema.displayOnly, title = schema.title, format = schema.format;
    var view = addViewAlternates([view_1.NodeType.TEXT_VIEW], (0, tslib_1.__assign)((0, tslib_1.__assign)({ type: DEFAULT_VIEW_TYPE, reference: '', schemaReference: '' }, defaults), { role: displayOnly ? view_1.Role.READER : view_1.Role.EDITOR, title: title }));
    if (view.value === undefined && view.reference === undefined) {
        view.value = schema.default;
    }
    if (view.value !== undefined && view.reference !== undefined) {
        view.value = undefined;
    }
    if (Array.isArray(schema.enum)) {
        return anyEnumerationToView(schema, view);
    }
    if (format === json_schema_validator_catalytic_web_1.JSONFormat.TIMEZONE) {
        var timezoneView = addViewAlternates([view_1.NodeType.SELECTION_VIEW, view_1.NodeType.RADIO_SELECTION_VIEW], view);
        timezoneView.optionValues = json_schema_validator_catalytic_web_1.TIMEZONES;
        return (0, view_1.selectionView)(timezoneView);
    }
    switch (schema.type) {
        case json_schema_validator_catalytic_web_1.JSONType.ARRAY:
            return arrayAnyToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.BOOLEAN:
            return booleanToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.INTEGER:
            return integerToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.NUMBER:
            return numberToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.OBJECT:
            return objectToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.STRING:
            return stringToView(schema, view);
        case json_schema_validator_catalytic_web_1.JSONType.NULL:
        default:
            return nullToView(schema, view);
    }
}
function jsonSchemaToView(schema, defaults) {
    return anyToView(schema, defaults);
}
exports.default = jsonSchemaToView;
//# sourceMappingURL=token.js.map